module.exports = __webpack_public_path__ + "img/Unidad16-2.1a501a44.png";